<button (click)="navigateToAllServices()" class="navBtn backButton" *ngIf="isMobileOrTablet">
    <img src="/assets/pages/truckModel/ArrowLeft.webp" />
    <!-- <span class="">{{'pages/services/viewallservices' | lowercase | translate}}</span> -->
     <span class="">View all services</span>
</button>